import { render, staticRenderFns } from "./SupplierCompanyProfile.vue?vue&type=template&id=101ecf53&scoped=true&"
import script from "./SupplierCompanyProfile.vue?vue&type=script&lang=js&"
export * from "./SupplierCompanyProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101ecf53",
  null
  
)

export default component.exports